export default "__VITE_ASSET__6d4d985f__"